import React, { useState } from 'react';
import { Eye, EyeOff, Mail, Lock, User, ArrowRight, ArrowLeft } from 'lucide-react';
interface SignUpPageProps {
  onNavigate: (page: string) => void;
}
export function SignUpPage({
  onNavigate
}: SignUpPageProps) {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: 'Mario Rossi',
    email: 'mario.rossi@greenback.com',
    password: 'password123',
    confirmPassword: 'password123',
    acceptTerms: true
  });
  const [isLoading, setIsLoading] = useState(false);
  const handleSignUp = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      onNavigate('onboarding');
    }, 1000);
  };
  return <div className="min-h-screen bg-green-600 flex flex-col items-center justify-center p-6 relative overflow-hidden" data-id="element-1851">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-cover bg-center opacity-10" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/wsCbUWp4TF3ni7DwEfb9qP/hand-drawn-turtle-shell-pattern_23-2150598661.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-1852" />

      <div className="w-full max-w-md relative z-10" data-id="element-1853">
        {/* Back Button */}
        <button onClick={() => onNavigate('login')} className="flex items-center gap-2 text-white hover:text-green-100 transition-colors mb-6" data-id="element-1854">
          <ArrowLeft className="h-5 w-5" data-id="element-1855" />
          <span className="text-sm font-medium" data-id="element-1856">Torna al login</span>
        </button>

        {/* Logo */}
        <div className="text-center mb-8" data-id="element-1857">
          <img src="https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png" alt="Greenback Logo" className="h-12 w-auto mx-auto mb-4 brightness-0 invert" data-id="element-1858" />
          <h1 className="text-2xl font-normal text-white" data-id="element-1859">Crea un account</h1>
          <p className="text-sm text-green-100 mt-2" data-id="element-1860">
            Inizia il tuo percorso verso la sostenibilità
          </p>
        </div>

        {/* Sign Up Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100" data-id="element-1861">
          <form onSubmit={handleSignUp} className="space-y-5" data-id="element-1862">
            {/* Name Input */}
            <div className="space-y-2" data-id="element-1863">
              <label className="text-sm font-medium text-gray-700 block" data-id="element-1864">
                Nome completo
              </label>
              <div className="relative" data-id="element-1865">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1866">
                  <User className="h-5 w-5 text-gray-400" data-id="element-1867" />
                </div>
                <input type="text" value={formData.name} onChange={e => setFormData({
                ...formData,
                name: e.target.value
              })} className="block w-full pl-10 pr-3 py-3 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 placeholder:text-sm focus:outline-none focus:border-green-500 focus:ring-1 focus:ring-green-500 transition-colors sm:text-sm" placeholder="Mario Rossi" required data-id="element-1868" />
              </div>
            </div>

            {/* Email Input */}
            <div className="space-y-2" data-id="element-1869">
              <label className="text-sm font-medium text-gray-700 block" data-id="element-1870">
                Email
              </label>
              <div className="relative" data-id="element-1871">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1872">
                  <Mail className="h-5 w-5 text-gray-400" data-id="element-1873" />
                </div>
                <input type="email" value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} className="block w-full pl-10 pr-3 py-3 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 placeholder:text-sm focus:outline-none focus:border-green-500 focus:ring-1 focus:ring-green-500 transition-colors sm:text-sm" placeholder="nome@esempio.com" required data-id="element-1874" />
              </div>
            </div>

            {/* Password Input */}
            <div className="space-y-2" data-id="element-1875">
              <label className="text-sm font-medium text-gray-700 block" data-id="element-1876">
                Password
              </label>
              <div className="relative" data-id="element-1877">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1878">
                  <Lock className="h-5 w-5 text-gray-400" data-id="element-1879" />
                </div>
                <input type={showPassword ? 'text' : 'password'} value={formData.password} onChange={e => setFormData({
                ...formData,
                password: e.target.value
              })} className="block w-full pl-10 pr-10 py-3 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 placeholder:text-sm focus:outline-none focus:border-green-500 focus:ring-1 focus:ring-green-500 transition-colors sm:text-sm" placeholder="••••••••" required minLength={8} data-id="element-1880" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-1881">
                  {showPassword ? <EyeOff className="h-5 w-5 text-gray-400 hover:text-gray-600" data-id="element-1882" /> : <Eye className="h-5 w-5 text-gray-400 hover:text-gray-600" data-id="element-1883" />}
                </button>
              </div>
              <p className="text-xs text-gray-500" data-id="element-1884">Minimo 8 caratteri</p>
            </div>

            {/* Confirm Password Input */}
            <div className="space-y-2" data-id="element-1885">
              <label className="text-sm font-medium text-gray-700 block" data-id="element-1886">
                Conferma password
              </label>
              <div className="relative" data-id="element-1887">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1888">
                  <Lock className="h-5 w-5 text-gray-400" data-id="element-1889" />
                </div>
                <input type={showConfirmPassword ? 'text' : 'password'} value={formData.confirmPassword} onChange={e => setFormData({
                ...formData,
                confirmPassword: e.target.value
              })} className="block w-full pl-10 pr-10 py-3 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 placeholder:text-sm focus:outline-none focus:border-green-500 focus:ring-1 focus:ring-green-500 transition-colors sm:text-sm" placeholder="••••••••" required data-id="element-1890" />
                <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-1891">
                  {showConfirmPassword ? <EyeOff className="h-5 w-5 text-gray-400 hover:text-gray-600" data-id="element-1892" /> : <Eye className="h-5 w-5 text-gray-400 hover:text-gray-600" data-id="element-1893" />}
                </button>
              </div>
            </div>

            {/* Terms Checkbox */}
            <div className="flex items-start" data-id="element-1894">
              <div className="flex items-center h-5" data-id="element-1895">
                <input id="terms" type="checkbox" checked={formData.acceptTerms} onChange={e => setFormData({
                ...formData,
                acceptTerms: e.target.checked
              })} className="w-4 h-4 border border-gray-300 rounded bg-white focus:ring-2 focus:ring-green-500 text-green-600" required data-id="element-1896" />
              </div>
              <div className="ml-3" data-id="element-1897">
                <label htmlFor="terms" className="text-xs text-gray-600" data-id="element-1898">
                  Accetto i{' '}
                  <button type="button" className="text-green-600 hover:text-green-700 font-medium" data-id="element-1899">
                    Termini e Condizioni
                  </button>{' '}
                  e la{' '}
                  <button type="button" className="text-green-600 hover:text-green-700 font-medium" data-id="element-1900">
                    Privacy Policy
                  </button>
                </label>
              </div>
            </div>

            {/* Sign Up Button */}
            <button type="submit" disabled={isLoading} className="w-full flex items-center justify-center py-3.5 px-4 border border-transparent rounded-full shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-1901">
              {isLoading ? <div className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin" data-id="element-1902" /> : <>
                  Crea account
                  <ArrowRight className="ml-2 h-4 w-4" data-id="element-1903" />
                </>}
            </button>
          </form>

          <div className="mt-6" data-id="element-1904">
            <div className="relative" data-id="element-1905">
              <div className="absolute inset-0 flex items-center" data-id="element-1906">
                <div className="w-full border-t border-gray-200" data-id="element-1907" />
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-1908">
                <span className="px-2 bg-white text-gray-500" data-id="element-1909">oppure</span>
              </div>
            </div>

            <div className="mt-6 text-center" data-id="element-1910">
              <p className="text-sm text-gray-600" data-id="element-1911">
                Hai già un account?{' '}
                <button type="button" onClick={() => onNavigate('login')} className="font-medium text-green-600 hover:text-green-700" data-id="element-1912">
                  Accedi
                </button>
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-green-100 mt-8" data-id="element-1913">
          &copy; 2024 Greenback. Tutti i diritti riservati.
        </p>
      </div>
    </div>;
}